<template>
  <div class="homeApp">
    <div class="header">
      <span class="">
        欢迎来到AI的世界
      </span>
      <img class="icon" src="../assets/app/menu.png" @click="showRight = true" alt="Image">
      <van-popup
        v-model="showRight"
        position="left"
        :style="{ width: '75%', height: '100%' }"
    >
    <div class="popover-content">
          <ul>
            <li v-for="item in menuItems" :key="item.id" @click="handleMenuItemClick(item)">
              <img :src="item.icon" alt="菜单项图标">
              <span>{{ item.name }}</span>
            </li>
          </ul>
        </div>
    </van-popup>

    </div>
    <div class="container" v-if="activeMenu === 'home'">
      <div class="top">
        我们可以做什么?
      </div>
      <div class="centext">与人对话互动，回答疑惑，文案创作，高效，便捷地帮助你获取信息、知识和灵感感</div>
      <div class="tips">
        <div class="item"><img src="../assets/pc/banner.png"><span>写一篇某贷产品的市场分析报告</span></div>
        <div class="item"><img src="../assets/pc/banner.png"><span>用Java帮我写一段递归算法的代码</span></div>
        <div class="item "><img src="../assets/pc/banner.png"><span>写一段封神电影观后感</span></div>
        <div class="item "><img src="../assets/pc/banner.png"><span>移民火星需要花费多少钱</span></div>
        <div class="item "><img src="../assets/pc/banner.png"><span>为什么太阳系中，水星和金星没有卫星</span></div>
      </div>
    </div>
    <iframe v-else :src="currentMenuUrl" frameborder="0" style="height: 90vh;width:100%"></iframe>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import { Popover, Cell, Popup } from 'vant'
import memuHome_click from '../assets/app/memuHome_click.png';
import memuHome_no from '../assets/app/memuHome_no.png';
import menuChatGPT_click from '../assets/app/menuChatGPT_click.png';
import menuChatGPT_no from '../assets/app/menuChatGPT_no.png';
import menuWen_click from '../assets/app/menuWen_click.png';
import menuWen_no from '../assets/app/menuWen_no.png';

Vue.use(Popover);

export default {
  name: 'HomeApp',
  components: {
    vanPopup: Popup
  },
  data() {
    return {
      datalist: [],
      activeMenu: 'home',
      currentMenuUrl: '',
      token: '',
      showRight: false,
      isMobile: false,// 根据判断是否是手机端
      // 通过 actions 属性来定义菜单选项
      menuItems: [{ id: 1, name: '首页', icon: memuHome_click, path: 'home' },
      { id: 2, name: 'ChatGPT', icon: menuChatGPT_click, path: 'chatai' },
      { id: 3, name: '文心千帆', icon: menuWen_click, path: 'baiduAi' }],
    }
  },
  mounted() {
    // 判断是否是手机端
    this.isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);
     if(!this.isMobile){
      this.$router.push('/homeWeb');
     }
    //判断token是否为空
    let token = localStorage.getItem('OWGW-token')
    if (token === '' || token === null){
      token =this.getQueryString('OWGW-token')
      localStorage.setItem('OWGW-token', token);
    }
  },
  methods: {
    handleMenuItemClick(item) {
      let token=localStorage.getItem('OWGW-token')
      // 在这里处理菜单项点击事件，切换页面
      switch (item.path) {
        case 'chatai':
        if (token === ''||token === null) {
          this.$router.push('/login');
          } else {
            this.submitCodeData(token)
          }
          break;
        case 'baiduAi':
        if (token === ''||token === null) {
            this.$router.push('/login');
          } else {
            this.currentMenuUrl = 'https://gpt.dashuf.com/wxweb/';
          }
          break;
        case 'product1':
          this.currentMenuUrl = 'https://www.example.com/product1';
          break;
        case 'product2':
          this.currentMenuUrl = 'https://www.example.com/product2';
          break;
        default:
          break;
      }
      this.activeMenu = item.path;
      this.showRight=false
    },
    //判断token是否过期
    submitCodeData(token) {
      let data = {"token":token};
      axios.post('/gptweb/owgw/verifyAndRenewToken', JSON.stringify(data), {
        headers: {
          'Content-Type': 'application/json'
        }
      })
        .then(response => {
          if(response.data.code === '200') {
            this.currentMenuUrl = 'https://gpt.dashuf.com/gpt/?OWGW-token=' + token;
          }else{
            this.$message.error(response.data.message)
            this.$router.push('/login');
          }
        })
        .catch(error => {
          console.error(error);
        });
    },
        // 查询字符串
     getQueryString(name) {
      var reg = new RegExp('[?&]' + name + '=([^&#]*)', 'i')
      var res = window.location.href.match(reg)
      if (res && res.length > 1) {
        return decodeURIComponent(res[1])
      } else {
        return ''
      }
    }
  }
}

</script>
<style scoped>
.homeApp {
  height: 100vh;
  overflow: hidden;
}
.header {
  float: center;
  font-family: PingFangSC-Regular;

  color: #333333;
  letter-spacing: 1.1px;
  font-weight: 400;
  padding: .3rem 0;
  position: relative;
}
.header span {
  font-size: .42rem;
  display: block;
  text-align: center;
  font-weight: 600;
}
.header .icon {
  width: .36rem;
  height: .36rem;
  margin-left: .2rem;
  position: absolute;
  left: .1rem;
  top: .35rem
}


.headerMenu {
  float: right;
  margin-right: 4px;
}

.container {
  display: block;
  height: 96%;
  /* 设置容器的高度为视口高度 */
  background-image: url('../assets/app/welcome.png');
  background-size: cover;
  background-position: center;
  position: relative;
}
.popover-content{
  width: 5rem;
  height: 1.8rem;
}
.popover-content img{
  margin-left: 5px;
  padding: 8px;
}
.popover-content li{
  display: flex;
    align-items: center;
    padding:6px
}
.popover-content span{
  font-family: PingFangSC-Regular;
  font-size: 18px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  text-align:left;
  margin-left: 5px;
  padding: 8px;
}
.tips {
  position: relative;
  top: 56%;

  left: 50%;
  margin-left: -30%;
}
.tips .item {
  position: relative;
  height: .5rem;
  margin-bottom: .3rem;
  box-sizing: border-box;
  line-height: .5rem;
  text-align: left;
  padding-left: .56rem;
}
.tips .item span {
  font-size: .28rem;
}
.tips .item img {
  position: absolute;
  left: 0;
  top: 0;
  width: 3.75rem;
  height: 100%;
}
.top {
  font-family: PingFangSC-Semibold;
  font-size: .34rem;
  color: #386CFF;
  letter-spacing: 0;
  font-weight: 600;
  position: absolute;
  top: 37%;
  left: 33%;
}

.centext {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  letter-spacing: 1.89px;
  font-weight: 500;
  position: absolute;
  top: 47%;
}
/* .first,.second,.third,.forth,.fifth {
  position: relative;
}

.first span {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: 60%;
  left: 22%;
}

.first img {
  opacity: 10;
  position: absolute;
  top: 58%;
  left: 10%;
}

.second span {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: 68%;
  left: 22%;
}

.second img {
  opacity: 10;
  position: absolute;
  top: 66%;
  left: 10%;
}

.third span {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: 76%;
  left: 22%;
}

.third img {
  opacity: 10;
  position: absolute;
  top: 74%;
  left: 10%;
}

.forth span {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: 84%;
  left: 22%;
}

.forth img {
  opacity: 10;
  position: absolute;
  top: 82%;
  left: 10%;
}

.fifth span {
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #333333;
  letter-spacing: 0;
  font-weight: 400;
  position: absolute;
  top: 92%;
  left: 22%;
}

.fifth img {
  opacity: 10;
  position: absolute;
  top: 90%;
  left: 10%;
} */
</style>
